module.exports = __webpack_public_path__ + "img/KDollarLogo.ae8b82cf.png";